export const URL_CHANGE = 'core/routing/broadcaster/URL_CHANGE';

export interface UrlChangeAction {
  type: typeof URL_CHANGE;
  url?: string;
}
